import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useState } from 'react';
import Cv from 'features/candidate/candidate-view/tabs/Cv';
import RecruitmentProcesses from 'features/candidate/candidate-view/tabs/RecruitmentProcesses';
import { useSelector } from 'react-redux';
import { TextField, Typography } from '@mui/material';

export default function LeftTabsContainer({ children }) {
  const [value, setValue] = useState('rp-notes');
  const hasLinkedIn = useSelector((state) => state?.currentCandidate?.linkedin || null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', overflowY: 'auto', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%', position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Tabs value={value} onChange={handleChange} aria-label="left tabs container">
          <Tab label="RP Notes" value="rp-notes" />
          <Tab label="CV" value="cv" />
          {hasLinkedIn && <Tab label="LinkedIn" value="linkedin" />}
        </Tabs>
      </Box>
      {value === 'rp-notes' && (
        <Box sx={{ p: 3 }}>
          <RecruitmentProcesses customButtonStyling={{position: 'unset', textAlign: 'right', marginTop: '16px'}}/>
        </Box>
      )}
      {value === 'cv' && (
        <Box sx={{ p: 3 }}>
          <Cv />
        </Box>
      )}
      {value === 'linkedin' && hasLinkedIn && (
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            LinkedIn Profile
          </Typography>
          <TextField
            component="a"
            href={`https://www.linkedin.com/in/${hasLinkedIn}`}
            target="_blank"
            rel="noopener noreferrer"
            fullWidth
            variant="outlined"
            value={`https://www.linkedin.com/in/${hasLinkedIn}`}
            InputProps={{
              readOnly: true
            }}
          />
        </Box>
      )}
    </Box>
  );
}